exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-response p[data-v-30667464]{margin:0}.modal_button[data-v-30667464]{margin:0;width:50%;border-radius:8px;border:1px solid hsla(0,0%,80%,.8);color:#272727;text-transform:none!important}", ""]);

// exports
